import { Box, Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';
import { EnhancedTicketsEventCard } from 'restful/accounts';

import GeneratingTickets from 'components/@account/GeneratingTickets';
import BorderStack from 'components/@common/BorderStack';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import EventListItem from 'components/@events/EventListItem';

import UpcomingEventItem from './UpcomingEventItem';

interface Props {
  events: Array<EnhancedTicketsEventCard>;
  isLoading?: boolean;
  isAccountOverview?: boolean;
  isGeneratingTickets?: boolean;
}

const UpcomingEvents = ({
  events,
  isLoading = false,
  isAccountOverview = false,
  isGeneratingTickets = false,
}: Props) => {
  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6">
          <FormattedMessage id="account.next.event.title" />
        </Typography>
        {isAccountOverview && (
          <Button
            variant="text"
            component={LinkUnstyled}
            href={Routes.AccountTickets}
          >
            <FormattedMessage id="account.tickets.upcoming.see_all" />
          </Button>
        )}
      </Box>
      {isGeneratingTickets && !isAccountOverview && <GeneratingTickets />}
      {isLoading && isAccountOverview && (
        <BorderStack>
          <EventListItem>
            <EventListItem.Loading />
          </EventListItem>
        </BorderStack>
      )}
      {isLoading && !isAccountOverview && (
        <div>
          <EventListItem>
            <EventListItem.Loading />
          </EventListItem>
        </div>
      )}
      {!!events.length && !isLoading && (
        <Stack
          sx={{
            gap: 2,
          }}
        >
          {events.map((event) => (
            <UpcomingEventItem
              key={event.id}
              event={event}
              hasBorder={isAccountOverview}
            />
          ))}
        </Stack>
      )}
      {!events.length && !isLoading && !isGeneratingTickets && (
        <BorderStack>
          <Typography
            variant="small"
            sx={{
              fontWeight: 'bold',
              mb: 1,
            }}
          >
            <FormattedMessage id="account.tickets.empty.title" />
          </Typography>
          <Typography
            variant="small"
            sx={{
              mb: 2,
            }}
          >
            <FormattedMessage id="account.tickets.empty.description" />
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            component={LinkUnstyled}
            href={Routes.Home}
            sx={{ width: { xs: '100%', md: 'fit-content' } }}
          >
            <FormattedMessage id="account.tickets.empty.button" />
          </Button>
        </BorderStack>
      )}
    </Stack>
  );
};

export default UpcomingEvents;
